import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return params
      .translateService
      .parser
      .interpolate(params.key, params.interpolateParams);
  }
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/translates/missing.service.ts